module.exports = __webpack_public_path__ + "assets/img/browser_dark.ba479624.png";